module.exports = __webpack_public_path__ + "static/media/WheatStage106.fbc3631f.PNG";